module.exports = __webpack_public_path__ + "img/dengji7.5d918c8c.png";